<template>
  <div class="to-page-container" v-loading="loading" element-loading-text="正在跳转到指定页面...">
    <div class="error" v-if="error">
      <el-result
        icon="error"
        title="页面跳转失败"
        :sub-title="errorMessage"
      >
        <template slot="extra">
          <el-button type="primary" @click="goHome">返回首页</el-button>
        </template>
      </el-result>
    </div>
    
    <div v-if="!loading && !error" class="debug-info">
      <p>调试信息：</p>
      <p>菜单ID: {{ themeMenuId }} (类型: {{ typeof themeMenuId }})</p>
      <p>钉钉授权码: {{ userDingId }} (已优化，不再存储到缓存)</p>
      <p>处理状态: {{ debugStatus }}</p>
    </div>
  </div>
</template>

<script>
import { GetAdminListById } from "network/login";

export default {
  name: "toPageKnowledge",
  data() {
    return {
      loading: true,
      error: false,
      errorMessage: "",
      themeMenuId: null,
      userDingId: null,
      debugStatus: "初始化",
      isDingLogin: false
    };
  },
  created() {
    // 获取URL参数
    const urlParams = new URLSearchParams(window.location.search);
    this.themeMenuId = this.$route.query.themenuid || urlParams.get('themenuid');
    this.userDingId = this.$route.query.userdingid || urlParams.get('userdingid');
    
    this.debugStatus = `获取到参数 - 菜单ID: ${this.themeMenuId}, 钉钉授权码: ${this.userDingId}`;
    
    // 如果没有菜单ID，直接跳转到首页
    if (!this.themeMenuId) {
      this.debugStatus = "没有菜单ID参数，跳转到首页";
      this.jumpToHomePage();
      return;
    }
    
    if (!this.userDingId) {
      this.showError("缺少钉钉授权码参数(userdingid)");
      return;
    }
    
    // 延迟执行，确保页面完全加载
    setTimeout(() => {
      this.handleDingLogin();
    }, 500);
  },
  methods: {
    // 处理钉钉登录
    async handleDingLogin() {
      try {
        this.loading = true;
        this.debugStatus = "开始获取钉钉账号列表";
        
        await this.getDingAdminList();
        
      } catch (error) {
        this.debugStatus = `钉钉登录错误: ${error.message}`;
        this.showError("钉钉登录失败，请重试");
      }
    },
    
    // 获取钉钉关联的账号列表
    async getDingAdminList() {
      if (this.isDingLogin) {
        return false;
      }
      
      this.isDingLogin = true;
      
      let res = await GetAdminListById(this.userDingId);
      this.isDingLogin = false;
      
      if (res.data.code == 1) {
        if (res.data.result && res.data.result.length) {
          this.debugStatus = `获取到${res.data.result.length}个关联账号，跳转到登录页面`;
          
          // 将管理员列表和相关参数传递给 LoginNew 页面
          this.jumpToLoginPage(res.data.result);
        } else {
          this.showError("未找到关联的账号");
        }
      } else {
        this.showError(res.data.message || "获取账号列表失败");
      }
    },
    
    // 跳转到登录页面
    jumpToLoginPage(adminList) {
      this.debugStatus = "跳转到登录页面";
      // 将管理员列表和目标菜单ID存储到sessionStorage
      const loginData = {
        adminList: adminList,
        themeMenuId: parseInt(this.themeMenuId) || this.themeMenuId,
        fromDingLogin: true
      };
      
      sessionStorage.setItem("dingLoginData", JSON.stringify(loginData));
      
      // 跳转到登录页面
      this.$router.push({
        path: "/login",
        query: { 
          fromDing: true,
          themenuid: this.themeMenuId
        }
      }).then(() => {
        // 跳转成功
      }).catch(err => {
        console.error("跳转登录页面失败:", err);
        this.showError("跳转失败，请重试");
      });
    },
    


    showError(message) {
      this.loading = false;
      this.error = true;
      this.errorMessage = message;
    },

    goHome() {
      this.$router.push("/");
    },

    // 跳转到首页（没有菜单ID时）
    jumpToHomePage() {
      this.debugStatus = "跳转到首页";
      
      this.$router.push("/").then(() => {
        // 跳转首页成功
      }).catch(err => {
        console.error("跳转首页失败:", err);
        // 如果路由跳转失败，直接刷新页面到首页
        window.location.href = window.location.origin + "/";
      });
    }
  },
};
</script>

<style scoped>
.to-page-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading {
  width: 100%;
  height: 100%;
  position: relative;
}

.error {
  width: 100%;
  max-width: 500px;
}


</style>